/** @format */

import TopContainer from "../CustomComponent/TopContainer";
import "../../../Css/Package and Plans/packageAndPlans.css";
import { Autocomplete, Checkbox, Dialog, IconButton, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import React, { useEffect, useState } from "react";
import ModuleDuration from "../CustomComponent/ModuleDuration";
import PackageDuration from "../CustomComponent/PackageDuration";
import { addPackageAPICall, addPlanAPICall, currentLoactionAPI, deletePackageAPICall, editPackageAPICall, generatePackageIdAPICall, getAllSubModuleAPICall, getAllSubModuleById, getModuleDurationAPICall, singlePackageAPICall, testAiKeyAPICall, viewAllPackageList, viewPackageDuration, viewPlanAPICall } from "../../../API/AddPackage/AddPackageAPI";
import { useSelector } from "react-redux";
import CountryListWithCode from "../../../Assets/JSON/CountryLIstWithCode.json"
import { SubModuleDuration } from "../CustomComponent/SubModuleDuration";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { AddSubModule } from "../CustomComponent/AddSubModule";
import uploadIcon from "../../../Assets/Images/uploadIcon.svg"
import { ContentPopup } from "./ContentPopup";
import SuccessSnackbar from "../../SingleCompoents/SnackBars/SuccessSnackbar";
import ErrorSnackbar from "../../SingleCompoents/SnackBars/ErrorSnackbar";
import { filterObjFromList } from "../../../Assets/JS/GeneraalFunctions";
import { getTaxListApiCall } from "../../../API/Tax/Tax";
import TurnoverConfig from "./TurnoverConfig";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PackageAndPlans = () => {
  const ErpTypes=[
    {name:"ERP-Autoparts"},
    {name:"ERP-Restaurant"},
    {name:"ERP-Textile"},
    {name:"ERP-Logistics"},
    {name:"ERP-Hotel"},
    {name:"ERP-Education"},
    {name:"ERP-Aviation"},
    {name:"ERP-Hospital"},
    {name:"ERP-Supermarket"},
    {name:"ERP-Tailors"},
    {name:"ERP-HOSPITALITY"},
    {name:"ERP-LEEYET"}
  ]

  // ---- LEEYET ERP suite -----------------------------------------------------
  // Backend writes these into LEEYETADMIN.packages: bundleCode, module.{crm,books,people,leeyetPayroll,publish,leeyetPos},
  // moduleTiers.{crm,books,people,payroll,publish,pos}, aiQuota.{monthlyRequests,modelTier}, maxUsers.
  // Selecting a preset auto-fills the section; admin can still tweak each field.
  const LEEYET_BUNDLE_OPTIONS = [
    { name: "Starter",    value: "leeyet_starter" },
    { name: "Growth",     value: "leeyet_growth" },
    { name: "Enterprise", value: "leeyet_enterprise" },
    { name: "Custom",     value: "custom" },
  ]
  const LEEYET_TIER_OPTIONS = ["none","starter","growth","enterprise"]
  const LEEYET_AI_TIER_OPTIONS = ["basic","pro","unlimited"]
  // AI provider integration options. 'leeyet' is the built-in fallback that
  // routes through the gateway service's env-configured key (so admins can
  // ship a package with AI features even without bringing their own key).
  const LEEYET_AI_PROVIDER_OPTIONS = [
    { value: "leeyet", label: "Leeyet AI (built-in, uses platform key)" },
    { value: "gemini", label: "Google Gemini" },
    { value: "openai", label: "OpenAI (GPT)" },
    { value: "azure",  label: "Azure OpenAI" },
  ]
  // Curated per-provider model catalog. The first entry is the default; the
  // `latest` aliases ride whatever Google/OpenAI currently expose as stable,
  // so admins don't need to chase version retirements (Google in particular
  // sunsets old `gemini-*` names every few months).
  // Keep "Custom…" last so admins can still paste an exotic deployment name.
  const LEEYET_AI_MODEL_CATALOG = {
    gemini: [
      { value: "gemini-2.5-flash",      label: "gemini-2.5-flash (fast, default)" },
      { value: "gemini-2.5-pro",        label: "gemini-2.5-pro (highest quality)" },
      { value: "gemini-flash-latest",   label: "gemini-flash-latest (alias, auto-upgrades)" },
      { value: "gemini-pro-latest",     label: "gemini-pro-latest (alias, auto-upgrades)" },
    ],
    openai: [
      { value: "gpt-4o-mini",           label: "gpt-4o-mini (fast, default)" },
      { value: "gpt-4o",                label: "gpt-4o (higher quality)" },
      { value: "gpt-4-turbo",           label: "gpt-4-turbo" },
      { value: "gpt-3.5-turbo",         label: "gpt-3.5-turbo (cheapest)" },
      { value: "o1-mini",               label: "o1-mini (reasoning)" },
    ],
  }
  const LEEYET_AI_EMBED_CATALOG = {
    gemini: [
      { value: "text-embedding-004",    label: "text-embedding-004 (default)" },
    ],
    openai: [
      { value: "text-embedding-3-small", label: "text-embedding-3-small (default)" },
      { value: "text-embedding-3-large", label: "text-embedding-3-large" },
      { value: "text-embedding-ada-002", label: "text-embedding-ada-002 (legacy)" },
    ],
  }
  const LEEYET_PRESETS = {
    leeyet_starter: {
      maxUsers: 5,
      aiMonthlyRequests: 500,
      aiModelTier: "basic",
      modules: { crm:true, books:true, people:false, payroll:false, publish:false, pos:true },
      tiers:   { crm:"starter", books:"starter", people:"none", payroll:"none", publish:"none", pos:"starter" },
    },
    leeyet_growth: {
      maxUsers: 25,
      aiMonthlyRequests: 5000,
      aiModelTier: "pro",
      modules: { crm:true, books:true, people:true, payroll:true, publish:true, pos:true },
      tiers:   { crm:"growth", books:"growth", people:"growth", payroll:"growth", publish:"starter", pos:"growth" },
    },
    leeyet_enterprise: {
      maxUsers: 0, // unlimited
      aiMonthlyRequests: 0, // unlimited
      aiModelTier: "unlimited",
      modules: { crm:true, books:true, people:true, payroll:true, publish:true, pos:true },
      tiers:   { crm:"enterprise", books:"enterprise", people:"enterprise", payroll:"enterprise", publish:"enterprise", pos:"enterprise" },
    },
  }
  // Hospitality mirrors the LEEYET bundle UI — same presets, hospitality_*
  // codes so the stored bundleCode identifies the ERP family.
  const HOSPITALITY_BUNDLE_OPTIONS = [
    { name: "Starter",    value: "hospitality_starter" },
    { name: "Growth",     value: "hospitality_growth" },
    { name: "Enterprise", value: "hospitality_enterprise" },
    { name: "Custom",     value: "custom" },
  ]
  const HOSPITALITY_PRESETS = {
    hospitality_starter:    LEEYET_PRESETS.leeyet_starter,
    hospitality_growth:     LEEYET_PRESETS.leeyet_growth,
    hospitality_enterprise: LEEYET_PRESETS.leeyet_enterprise,
  }
  const durationType=[
    {name:"Month"},{name:"Year"}
  ]

  //useSelector
  const packageId=useSelector((state)=>state.generatePackageIdSlice.value)
  // package list
  const packageList=useSelector((state)=>state.generatePackageIdSlice?.value1)
  // single package
  const singlePackage=useSelector((state)=>state.generatePackageIdSlice?.singlePackage)
  // package duration list
  const packageDurationList=useSelector((state)=>state.generatePackageIdSlice.value2)
  //moduleDuration list
  const moduleDurationList=useSelector((state)=>state.generatePackageIdSlice.value3)
  // subMOduleList
  const subModuleList=useSelector((state)=>state.generatePackageIdSlice.value4)
  // submoduleListById
  const subModuleIdById=useSelector((state)=>state.generatePackageIdSlice.value5)
  // view plan 
  const planList=useSelector((state)=>state.generatePackageIdSlice.plan)
  const TaxList = useSelector((state) => state.TaxListSlice.value);
 

  // input states
  const [openModule, setOpenModule] = useState(false);
  const [openPackage, setOpenPackage] = useState(false);
  const [openSubModule,setOpenSubModule]=useState(false)
  const [isModify,setIsModify]=useState(false)
  const [subModuleArray,setSubModuleArray]=useState([])
  const [contentToBackend,setContentToBackend]=useState([])
  const [planType,setplanType]=useState("")
  
  const addPackageForm={
    country:null,
    typeOfErp:null,
    distributionPrice:'',
    packageDuration:durationType[0], // Changed to Month as default
    backupPrice:'',
    module:null,
    subModule:null,
    addingLocationPrice:0,
    sellingPrice:0,
    durationType:"",
    discription:'',
    tax:0,
    cess:0,
    taxPercentage:0,
    taxType:'VAT',
    planType:null,
    isMobilePackage:false,
    planPrice:0,
    mobilepackagePrice:"",
    mobileLocPrice:"",
    color:"",
    image:null,
    imageName:"",
    tax:[],
    released:false,
    billingType:'fixed', // 'fixed' or 'turnover'
    turnoverEnabled:false,
    turnoverLimitType:'monthly', // 'monthly' or 'yearly'
    turnoverLimitAmount:0,
    turnoverBasePrice:0,
    overageEnabled:false,
    overageRate:0,
    overageRateType:'percentage', // 'percentage' or 'fixed'
    pricingTiers:[], // [{from, to, price}]
    // LEEYET ERP suite fields (only used when typeOfErp.name === "ERP-LEEYET")
    leeyetBundle:null,           // one of LEEYET_BUNDLE_OPTIONS
    leeyetMaxUsers:0,
    leeyetAiMonthlyRequests:0,
    leeyetAiModelTier:"basic",
    leeyetModuleCrm:false,
    leeyetModuleBooks:false,
    leeyetModulePeople:false,
    leeyetModulePayroll:false,
    leeyetModulePublish:false,
    leeyetModulePos:false,
    leeyetTierCrm:"none",
    leeyetTierBooks:"none",
    leeyetTierPeople:"none",
    leeyetTierPayroll:"none",
    leeyetTierPublish:"none",
    leeyetTierPos:"none",
    // AI provider integration (per-bundle).
    // `leeyetAiApiKey` is intentionally NOT hydrated from the server (it
    // stores the ciphertext); an empty value on submit means "keep current".
    leeyetAiProvider:        "leeyet",
    leeyetAiApiKey:          "",
    leeyetAiApiKeyMasked:    "",
    leeyetAiBaseUrl:         "",
    leeyetAiChatModel:       "",
    leeyetAiEmbedModel:      "",
    leeyetAiEndpoint:        "",
    leeyetAiChatDeployment:  "",
    leeyetAiEmbedDeployment: "",
    leeyetAiApiVersion:      "",
    leeyetAiLastTestStatus:  "",
    leeyetAiLastTestError:   "",
    leeyetAiTesting:         false,
    leeyetAiTestMsg:         "",
    // Per-provider config store: { gemini: { apiKeyMasked, chatModel, ... }, openai: { ... } }
    // Used to restore settings when switching providers in the dropdown.
    leeyetAiProviderConfigs: {},
    // Per-seat license rate (used when admin adds extra seats beyond the bundle baseline)
    leeyetLicenseRate:0,
    // Subscription tiers for LEEYET (monthly / quarterly / yearly / ...)
    // Each: { code, label, durationValue, durationUnit, price, benefit, discountPercent, isDefault, isActive }
    leeyetBillingCycles: [
      { code: "monthly", label: "Monthly", durationValue: 1, durationUnit: "Month",
        price: 0, benefit: "", discountPercent: 0, isDefault: true,  isActive: true },
      { code: "yearly",  label: "Yearly",  durationValue: 1, durationUnit: "Year",
        price: 0, benefit: "Save vs monthly", discountPercent: 0, isDefault: false, isActive: true },
    ],
  }
  const [addPackage,setAddPackage]=useState(addPackageForm)
  const [moduleArray,setModuleArray]=useState([])
  const [resultArray, setResultArray] = useState([]);
  const [data, setData] = useState([]);
  const [country,setCountry]=useState()
  const [addPlan,setAddPlan]=useState(false)
  const [addSubModule,setAddSubModule]=useState(false)
  const [contentPopup,setContentPopup]=useState(false)
  const [image,setImage]=useState()
  const [imageName,setImageName]=useState('')
  const [editedId,setEditedId]=useState()
  const [snackBarStates,setSnackBarStates]=useState({
    success:false,
    error:false,
    snackMsg:"",
  })
  const [updatedTaxArray, setUpdatedTaxArray] = useState([]);
  const [transactionId,setTransactionId]=useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  
  useEffect(()=>{
    setUpdatedTaxArray(TaxList?.map((obj) => {
      return obj;
    }) ?? [])
  },[TaxList])
  useEffect(()=>{
    setTransactionId(`${packageId?.prefix}${packageId?.transNo}`)
  },[packageId])
  console.log(TaxList);
  console.log(updatedTaxArray);
  console.log(addPackage);
 
  const handleCloseSuccess=()=>()=>{
    setSnackBarStates({...snackBarStates,error:false,success:false})
}
  

  const updateListner=()=>{
    setIsModify(!isModify)
  }

  const clickModuleDuration = () => {
    setOpenModule(true);
  };
  const clickPackageDuration = () => {
    setOpenPackage(true);
  };
  const closeConfirmDialog = () => {
    setOpenModule(false);
    setOpenPackage(false);
  };
  const clickSubModuleDuration=()=>{
    setOpenSubModule(true)
  }
  const closeSubModuleDuration=()=>{
    setOpenSubModule(false)
  }


  // useEffect
  useEffect(()=>{
    
    generatePackageIdAPICall()
    viewAllPackageList()
    viewPackageDuration()
    // getModuleDurationAPICall()
    // getAllSubModuleAPICall()
    viewPlanAPICall()

  },[isModify])

  useEffect(()=>{
    getTaxListApiCall({country:addPackage?.country?.name})
  },[addPackage?.country])


  // useEffect(()=>{
  //   viewAllPackageList({country:country?.name})
  // },[country])


  // useEffect(()=>{
  //   getAllSubModuleById({moduleId:addPackage?.module})
  // },[addPackage?.module])

// 
  // onChange function
const getAddPackage=(key)=>(e,newValue)=>{
  //  const {value}=e.target.value
    if(key==="country") {
      setAddPackage({...addPackage,country:newValue})
    }
    if(key==="typeOfErp") {
      setAddPackage({...addPackage,typeOfErp:newValue})
    }
    if(key==="distributionPrice"){
      setAddPackage({...addPackage,distributionPrice:e.target.value})
    }
    if(key==="packageDuration"){
      setAddPackage({...addPackage,packageDuration:newValue})
    }
    if(key==="backupPrice"){
      setAddPackage({...addPackage,backupPrice:e.target.value})
    }
    if(key==="module"){
      setAddPackage({...addPackage,module:newValue})
    }
    if(key==="subModule"){
      setAddPackage({...addPackage,subModule:newValue})
    }
    if(key==="addingLocationPrice"){
      setAddPackage({...addPackage,addingLocationPrice:e.target.value})
    }
    if(key==="sellingPrice"){
      setAddPackage({...addPackage,sellingPrice:e.target.value})
    }
    if(key==="durationType"){
      setAddPackage({...addPackage,durationType:e.target.value})
    }
    if(key==="discription"){
      setAddPackage({...addPackage,discription:e.target.value})
    }
    if(key==="tax"){
      setAddPackage({...addPackage,tax:e.target.value})
    }
    if(key==="cess"){
      setAddPackage({...addPackage,cess:e.target.value})
    }
    if(key==="planType"){
      setAddPackage({...addPackage,planType:newValue})
    }
    if(key==="planPrice"){
      setAddPackage({...addPackage,planPrice:e.target.value})
    }
    if(key==="isMobilePackage"){
      setAddPackage({...addPackage,isMobilePackage:e.target.checked})
    }
    if(key==="mobilepackagePrice"){
      setAddPackage({...addPackage,mobilepackagePrice:e.target.value})
    }
    if(key==="mobileLocPrice"){
      setAddPackage({...addPackage,mobileLocPrice:e.target.value})
    }
    if(key==="color"){
      setAddPackage({...addPackage,color:e.target.value})
    }
    if(key==="durationType"){
      setAddPackage({...addPackage,durationType:e.target.value})
    }
    if (key === "tax") {
       const selectedTaxId =newValue?.length !== 0 ? newValue[0]?.includedPrice : undefined;
       const newFilteredTaxOptions =selectedTaxId !== undefined? TaxList.filter((option) => option.includedPrice === selectedTaxId)
        : TaxList;
        setUpdatedTaxArray(newFilteredTaxOptions)
        setAddPackage({...addPackage,tax:newValue})
       
    }

}

const handlePaste = (event) => {
  const pastedText = event.clipboardData.getData('text');
  // Assuming the pasted text is a valid color code
  // You may want to perform validation here
  setAddPackage({ ...addPackage, color: pastedText });
  event.preventDefault();
};

// useEffect(()=>{
//   setAddPackage({...addPackage,sellingPrice:
//     (addPackage?.planPrice === "" ? 0 : parseFloat(addPackage?.planPrice))+(addPackage?.addingLocationPrice === "" ? 0 : parseFloat(addPackage?.addingLocationPrice))

//   })
// },[addPackage?.planPrice,addPackage?.addingLocationPrice])

const getImage=(e)=>{
  setImage(e.target.files[0])
  setImageName(e.target.files[0]?.name)
}

const addNewPlan=async ()=>{
  const name = (planType || "").trim()
  if (!name) {
    setSnackBarStates({ ...snackBarStates, error: true, snackMsg: "Enter a plan name" })
    return
  }
  const { planType: created, created: didCreate } = await addPlanAPICall({ name })
  if (didCreate) {
    setSnackBarStates({ ...snackBarStates, success: true, snackMsg: "Plan added" })
    setplanType("")
  } else if (created) {
    setSnackBarStates({ ...snackBarStates, error: true, snackMsg: "Plan already exists" })
  } else {
    setSnackBarStates({ ...snackBarStates, error: true, snackMsg: "Failed to add plan" })
  }
}




// add button function
const addButtonFn=()=>{

 

    // setModuleArray([...moduleArray,
    //   {
    //     moduleId:addPackage?.module?._id,
    //     moduleName:addPackage?.module?.name,
    //     submodule:addPackage?.subModule
       
    //   }
    //   ])


    // first
    const newModuleId = addPackage?.module?._id;
    const newSubModule = addPackage?.subModule; 
    const moduleName=addPackage?.module?.name;

    // Check if the moduleId already exists in the data
    const existingData = moduleArray.find((item) => item.moduleId === newModuleId);
   
    if (existingData) {
      console.log(existingData);
      // If moduleId exists, add the new submodule to the subModule array
      if(existingData?.submodule?.some(obj=>obj?._id===newSubModule?._id)){
        alert("sub module already exist")
      }
      else{
        setModuleArray((prevData) =>
        prevData.map((item) => {
          if (item.moduleId === newModuleId) {
            return {
            
              ...item,
              submodule: [...item.submodule, newSubModule ]
            };
          }
          console.log(item);
          return item;
          
        })
      );
      }
      
    } else {
      // If moduleId doesn't exist, create a new object with the submodule array
      setModuleArray((prevData) => [
        ...prevData,
        {
          moduleId: newModuleId,
          submodule: [newSubModule],
          moduleName:moduleName
        }
      ]);
    }
    setAddPackage({...addPackage,
        subModule:null
        })
}







const clearState=()=>{
  setAddPackage(addPackageForm)
  setModuleArray([])
  setContentToBackend([])
  setSubModuleArray([])
  setImageName('')
  setImage()
  // setTransactionId("")
}



const handleSubModuleDataUpdate = (data) => {
  // const transformedObject = {};
  // data.forEach(item => {
  //     transformedObject[item.name] = item.isChecked;
  // });
  // setSubModuleArray(transformedObject);
  setSubModuleArray(data)
};

console.log(subModuleArray);

const handleContentUpdate=(data)=>{
  setContentToBackend(data)
}
console.log(contentToBackend);

const getSubModuleFlag=(index)=>Boolean(subModuleArray?.[index]?.isChecked)

const bodyToPackageAndPlans={
  packageName:addPackage?.typeOfErp?.name,
  erpType:addPackage?.typeOfErp?.name,
  country:addPackage?.country?.name,
  packageDuration:addPackage?.packageDuration?.duration,
  // durationType:addPackage?.durationType?.type,
  distributionPrice:Number(addPackage?.distributionPrice),
  backupPrice:Number(addPackage?.backupPrice),
  module:{
    basic:getSubModuleFlag(0),
    accounts:getSubModuleFlag(1),
    payroll:getSubModuleFlag(2),
    mobileService:getSubModuleFlag(3)
  },
  sellingPrice:Number(addPackage?.sellingPrice),
  locationPrice:Number(addPackage?.addingLocationPrice),
  description:addPackage?.discription,
  planType:addPackage?.planType?._id,
  // vatorgst:addPackage?.tax,
  // cess:addPackage?.cess
  isMobilePackage:addPackage?.isMobilePackage,
  planPrice:addPackage?.planPrice,
  mobilepackagePrice:Number(addPackage?.mobilepackagePrice),
  mobileLocPrice:Number(addPackage?.mobileLocPrice)

}
const formData=new FormData()
formData.append("packageName",addPackage?.typeOfErp?.name)
formData.append("country",addPackage?.country?.name)
formData.append("packageDuration",addPackage?.durationType)
formData.append("durationType",addPackage?.packageDuration?.name)
formData.append("distributionPrice",Number(addPackage?.distributionPrice))
formData.append("backupPrice",Number(addPackage?.backupPrice))
// Build module object: legacy fields from sub-modules + LEEYET module flags when applicable.
const _isLeeyet = addPackage?.typeOfErp?.name === "ERP-LEEYET"
// Seat-licensed ERPs share the license fields (maxUsers / licenseRate /
// billingCycles) and the full bundle configuration UI.
const _isLicensed = _isLeeyet || addPackage?.typeOfErp?.name === "ERP-HOSPITALITY"
const _bundleOptions = _isLeeyet ? LEEYET_BUNDLE_OPTIONS : HOSPITALITY_BUNDLE_OPTIONS
const _bundlePresets = _isLeeyet ? LEEYET_PRESETS : HOSPITALITY_PRESETS
const _moduleObj = {
  basic: getSubModuleFlag(0),
  accounts: getSubModuleFlag(1),
  payroll: getSubModuleFlag(2),
  mobileService: getSubModuleFlag(3),
}
if (_isLicensed) {
  _moduleObj.crm           = !!addPackage?.leeyetModuleCrm
  _moduleObj.books         = !!addPackage?.leeyetModuleBooks
  _moduleObj.people        = !!addPackage?.leeyetModulePeople
  _moduleObj.leeyetPayroll = !!addPackage?.leeyetModulePayroll
  _moduleObj.publish       = !!addPackage?.leeyetModulePublish
  _moduleObj.leeyetPos     = !!addPackage?.leeyetModulePos
}
formData.append("module", JSON.stringify(_moduleObj))
if (_isLicensed) {
  if (addPackage?.leeyetBundle?.value && addPackage.leeyetBundle.value !== "custom") {
    formData.append("bundleCode", addPackage.leeyetBundle.value)
  }
  formData.append("moduleTiers", JSON.stringify({
    crm:     addPackage?.leeyetTierCrm     || "none",
    books:   addPackage?.leeyetTierBooks   || "none",
    people:  addPackage?.leeyetTierPeople  || "none",
    payroll: addPackage?.leeyetTierPayroll || "none",
    publish: addPackage?.leeyetTierPublish || "none",
    pos:     addPackage?.leeyetTierPos     || "none",
  }))
  formData.append("aiQuota", JSON.stringify({
    monthlyRequests: Number(addPackage?.leeyetAiMonthlyRequests) || 0,
    modelTier:       addPackage?.leeyetAiModelTier || "basic",
  }))
  // AI provider integration. Send an empty apiKey on edit to mean
  // "keep current key" — backend never round-trips the ciphertext.
  formData.append("aiConfig", JSON.stringify({
    provider:        addPackage?.leeyetAiProvider        || "leeyet",
    apiKey:          (addPackage?.leeyetAiApiKey || "").trim(),
    baseUrl:         (addPackage?.leeyetAiBaseUrl         || "").trim(),
    chatModel:       (addPackage?.leeyetAiChatModel       || "").trim(),
    embedModel:      (addPackage?.leeyetAiEmbedModel      || "").trim(),
    endpoint:        (addPackage?.leeyetAiEndpoint        || "").trim(),
    chatDeployment:  (addPackage?.leeyetAiChatDeployment  || "").trim(),
    embedDeployment: (addPackage?.leeyetAiEmbedDeployment || "").trim(),
    apiVersion:      (addPackage?.leeyetAiApiVersion      || "").trim(),
    enabled:         true,
  }))
}
// Seat-license fields apply to all licensed ERPs (LEEYET + HOSPITALITY).
if (_isLicensed) {
  formData.append("maxUsers", Number(addPackage?.leeyetMaxUsers) || 0)
  // Per-seat license rate (used by Registered Users license adjust UI)
  formData.append("licenseRate", Number(addPackage?.leeyetLicenseRate) || 0)
  // Subscription tiers / billing cycles
  formData.append("billingCycles", JSON.stringify(
    (addPackage?.leeyetBillingCycles || [])
      .filter((c) => c && (c.code || c.label))
      .map((c) => ({
        code:           String(c.code || "").trim(),
        label:          String(c.label || "").trim(),
        durationValue:  Number(c.durationValue) || 1,
        durationUnit:   c.durationUnit || "Month",
        price:          Number(c.price) || 0,
        benefit:        String(c.benefit || ""),
        discountPercent: Number(c.discountPercent) || 0,
        isDefault:      !!c.isDefault,
        isActive:       c.isActive === undefined ? true : !!c.isActive,
      }))
  ))
}
formData.append("sellingPrice",Number(addPackage?.sellingPrice))
formData.append("locationPrice",Number(addPackage?.addingLocationPrice))
// formData.append("description")
// Only append planType when actually selected; otherwise the FormData would
// send the literal string "undefined" which Mongoose can't cast to ObjectId.
if (addPackage?.planType?._id) {
  formData.append("planType", addPackage.planType._id)
}
formData.append("erpType",addPackage?.typeOfErp?.name)
formData.append("isMobilePackage",addPackage?.isMobilePackage)
// formData.append("planPrice",addPackage?.planPrice)
formData.append("planPrice",0)
formData.append("mobilepackagePrice",Number(addPackage?.mobilepackagePrice))
formData.append("mobileLocPrice",Number(addPackage?.mobileLocPrice))
formData.append("additionalInfo",JSON.stringify(contentToBackend))
{image !== undefined && formData.append("file",image)}

formData.append("hexCode",addPackage?.color)
formData.append("description",addPackage?.discription)
addPackage?.tax?.length > 0 && addPackage?.tax?.map((obj)=>{
  formData.append("taxArray",obj?._id)
}) 
formData.append("tax",Number(addPackage?.taxPercentage) || 0)
formData.append("taxType",addPackage?.taxType || 'VAT')
formData.append("released",addPackage?.released)

// Turnover-based billing fields
formData.append("billingType",addPackage?.billingType || 'fixed')
if(addPackage?.billingType === 'turnover'){
  formData.append("turnoverConfig",JSON.stringify({
    enabled: addPackage?.turnoverEnabled || false,
    limitType: addPackage?.turnoverLimitType || 'monthly',
    limitAmount: Number(addPackage?.turnoverLimitAmount) || 0,
    basePrice: Number(addPackage?.turnoverBasePrice) || 0,
    overage: {
      enabled: addPackage?.overageEnabled || false,
      rate: Number(addPackage?.overageRate) || 0,
      rateType: addPackage?.overageRateType || 'percentage'
    },
    tiers: addPackage?.pricingTiers || []
  }))
}

const packageSubmitBtnFn=async ()=>{
  // For ERP-LEEYET: auto-link the selected Bundle to a planType so the
  // backend `planType` FK is always populated (and the package list shows
  // the bundle name in the "Plan Type" column). Idempotent — reuses an
  // existing planType by name or creates one on the fly.
  try {
    if (_isLicensed && !addPackage?.planType?._id && addPackage?.leeyetBundle?.name) {
      const bundleName = addPackage.leeyetBundle.name
      const existing = (planList || []).find(
        (p) => (p?.name || "").trim().toLowerCase() === bundleName.trim().toLowerCase()
      )
      let linkedPlanTypeId = existing?._id
      if (!linkedPlanTypeId) {
        const { planType } = await addPlanAPICall({ name: bundleName })
        linkedPlanTypeId = planType?._id
      }
      if (linkedPlanTypeId) {
        // Overwrite (or set) planType in the already-built formData.
        formData.delete && formData.delete("planType")
        formData.append("planType", linkedPlanTypeId)
      }
    }
  } catch (e) {
    console.error("bundle -> planType auto-link failed", e)
  }

  addPackageAPICall(formData,clearState,updateListner,setSnackBarStates,snackBarStates)
}

const deletePackageFn=(id)=>{
  deletePackageAPICall(id,updateListner,setSnackBarStates,snackBarStates)
}

const editPackageFunction=(id)=>{
  singlePackageAPICall({packageId:id})
  setEditedId(id)
  setImage()
}

const editSubmitFunction=async ()=>{
   // Mirror packageSubmitBtnFn: ensure licensed-ERP edits also keep planType in sync with the bundle.
   try {
     if (_isLicensed && !addPackage?.planType?._id && addPackage?.leeyetBundle?.name) {
       const bundleName = addPackage.leeyetBundle.name
       const existing = (planList || []).find(
         (p) => (p?.name || "").trim().toLowerCase() === bundleName.trim().toLowerCase()
       )
       let linkedPlanTypeId = existing?._id
       if (!linkedPlanTypeId) {
         const { planType } = await addPlanAPICall({ name: bundleName })
         linkedPlanTypeId = planType?._id
       }
       if (linkedPlanTypeId) {
         formData.delete && formData.delete("planType")
         formData.append("planType", linkedPlanTypeId)
       }
     }
   } catch (e) {
     console.error("LEEYET bundle -> planType auto-link (edit) failed", e)
   }
   formData.append("_id",editedId)
   editPackageAPICall(formData,clearState,updateListner,setSnackBarStates,snackBarStates)
}

useEffect(()=>{
   if(singlePackage !== undefined){
    setAddPackage({...addPackage,
     country:filterObjFromList("name",CountryListWithCode,"country",singlePackage),
     typeOfErp:filterObjFromList("name",ErpTypes,"erpType",singlePackage),
     distributionPrice:singlePackage?.distributionPrice,
     packageDuration:filterObjFromList("name",durationType,"durationType",singlePackage),
     durationType:singlePackage?.packageDuration,
     backupPrice:singlePackage?.backupPrice,
     planType:filterObjFromList("_id",planList,"planType",singlePackage),
     planPrice:singlePackage?.planPrice,
     sellingPrice:singlePackage?.sellingPrice,
     mobilepackagePrice:singlePackage?.mobilepackagePrice,
     mobileLocPrice:singlePackage?.mobileLocPrice,
     discription:singlePackage?.description,
     color:singlePackage?.hexCode,
     released:singlePackage?.released,
     tax:updatedTaxArray.filter(item => singlePackage?.taxArray.includes(item._id)),
     taxPercentage:singlePackage?.tax || 0,
     taxType:singlePackage?.taxType || 'VAT',
     addingLocationPrice:singlePackage?.locationPrice,
     // Load turnover fields
     billingType:singlePackage?.billingType || 'fixed',
     turnoverEnabled:singlePackage?.turnoverConfig?.enabled || false,
     turnoverLimitType:singlePackage?.turnoverConfig?.limitType || 'monthly',
     turnoverLimitAmount:singlePackage?.turnoverConfig?.limitAmount || 0,
     turnoverBasePrice:singlePackage?.turnoverConfig?.basePrice || 0,
     overageEnabled:singlePackage?.turnoverConfig?.overage?.enabled || false,
     overageRate:singlePackage?.turnoverConfig?.overage?.rate || 0,
     overageRateType:singlePackage?.turnoverConfig?.overage?.rateType || 'percentage',
     pricingTiers:singlePackage?.turnoverConfig?.tiers || [],
     // LEEYET ERP suite hydration (also resolves hospitality_* bundles)
     leeyetBundle: filterObjFromList("value", LEEYET_BUNDLE_OPTIONS, "bundleCode", singlePackage)
                   || filterObjFromList("value", HOSPITALITY_BUNDLE_OPTIONS, "bundleCode", singlePackage)
                   || (singlePackage?.bundleCode ? null : null),
     leeyetMaxUsers: singlePackage?.maxUsers ?? 0,
     leeyetAiMonthlyRequests: singlePackage?.aiQuota?.monthlyRequests ?? 0,
     leeyetAiModelTier: singlePackage?.aiQuota?.modelTier || "basic",
     // AI provider integration — apiKey is intentionally NOT pulled from
     // the server (backend strips ciphertext). Empty value on save means
     // "keep the current encrypted key".
     leeyetAiProvider:        singlePackage?.aiConfig?.provider        || "leeyet",
     leeyetAiApiKey:          "",
     leeyetAiApiKeyMasked:    singlePackage?.aiConfig?.apiKeyMasked    || "",
     leeyetAiBaseUrl:         singlePackage?.aiConfig?.baseUrl         || "",
     leeyetAiChatModel:       singlePackage?.aiConfig?.chatModel       || "",
     leeyetAiEmbedModel:      singlePackage?.aiConfig?.embedModel      || "",
     leeyetAiEndpoint:        singlePackage?.aiConfig?.endpoint        || "",
     leeyetAiChatDeployment:  singlePackage?.aiConfig?.chatDeployment  || "",
     leeyetAiEmbedDeployment: singlePackage?.aiConfig?.embedDeployment || "",
     leeyetAiApiVersion:      singlePackage?.aiConfig?.apiVersion      || "",
     leeyetAiLastTestStatus:  singlePackage?.aiConfig?.lastTestStatus  || "",
     leeyetAiLastTestError:   singlePackage?.aiConfig?.lastTestError   || "",
     leeyetAiTesting:         false,
     leeyetAiTestMsg:         "",
     leeyetAiProviderConfigs: singlePackage?.providerConfigs || {},
     leeyetModuleCrm:     !!singlePackage?.module?.crm,
     leeyetModuleBooks:   !!singlePackage?.module?.books,
     leeyetModulePeople:  !!singlePackage?.module?.people,
     leeyetModulePayroll: !!singlePackage?.module?.leeyetPayroll,
     leeyetModulePublish: !!singlePackage?.module?.publish,
     leeyetModulePos:     !!singlePackage?.module?.leeyetPos,
     leeyetTierCrm:     singlePackage?.moduleTiers?.crm     || "none",
     leeyetTierBooks:   singlePackage?.moduleTiers?.books   || "none",
     leeyetTierPeople:  singlePackage?.moduleTiers?.people  || "none",
     leeyetTierPayroll: singlePackage?.moduleTiers?.payroll || "none",
     leeyetTierPublish: singlePackage?.moduleTiers?.publish || "none",
     leeyetTierPos:     singlePackage?.moduleTiers?.pos     || "none",
     leeyetLicenseRate: singlePackage?.licenseRate ?? 0,
     leeyetBillingCycles:
       Array.isArray(singlePackage?.billingCycles) && singlePackage.billingCycles.length > 0
         ? singlePackage.billingCycles.map((c) => ({
             code: c.code || "",
             label: c.label || "",
             durationValue: Number(c.durationValue) || 1,
             durationUnit: c.durationUnit || "Month",
             price: Number(c.price) || 0,
             benefit: c.benefit || "",
             discountPercent: Number(c.discountPercent) || 0,
             isDefault: !!c.isDefault,
             isActive: c.isActive === undefined ? true : !!c.isActive,
           }))
         : [
             { code: "monthly", label: "Monthly", durationValue: 1, durationUnit: "Month",
               price: 0, benefit: "", discountPercent: 0, isDefault: true,  isActive: true },
             { code: "yearly",  label: "Yearly",  durationValue: 1, durationUnit: "Year",
               price: 0, benefit: "Save vs monthly", discountPercent: 0, isDefault: false, isActive: true },
           ],
    // tax:singlePackage?.taxArray
    
    })
    // const jsonString = 'singlePackage?.module';
    // const parsedObject = JSON.parse(singlePackage?.module);
  let data = Object.keys(singlePackage?.module).map(key => ({
      name: key,
      isChecked: singlePackage?.module[key]
  }));
    setSubModuleArray(data)
    setContentToBackend(singlePackage?.additionalInfo)
    // setImage(`data:name;base64,${singlePackage?.logo?.data}`)
    // setImage(singlePackage?.logo?.data)
    setImageName(singlePackage?.logo?.name)
    setTransactionId(singlePackage?.packageId)
    
  }
},[singlePackage])




console.log(addPackage);








  return (
    <>
      <TopContainer label="Package & Plans" />
      <div className="global-container package-plans-parent">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
           <h3>Add Package & Plans</h3>
                  <div style={{display:"flex",margin:"0 20px",alignItems:"center"}}>
                      <input
                           className="toggle-checkbox"
                           type={"checkbox"}
                           checked={addPackage?.released}
                           onChange={(e)=>setAddPackage({...addPackage,released:e.target.checked})}
                           name="released"
                       />
                      <label htmlFor="" style={{fontSize:"0.8rem",marginLeft:"4px"}}>Released</label>
                  </div>
                     
           <div>
             <input 
               type="checkbox"  
               style={{accentColor:"red",width:"20px",cursor:"pointer"}}
              checked={addPackage?.isMobilePackage}
              onChange={getAddPackage('isMobilePackage')}
              />
             <label htmlFor="" style={{fontSize:"0.8rem",color:"red",fontWeight:600}}>Mobile Package</label>
           </div>
        </div>
       
        <hr />
        <div className="add-package-form">
          <div className="global-single-input" style={{width:"30%"}}>
            <p>Transaction ID</p>
            <input
              disabled
              value={transactionId}
            />
          </div>
          <div className="global-single-input auto-complete" style={{width:"30%"}}>
            <p>Country</p>
            <Autocomplete
              sx={{width:"100%"}}
              options={CountryListWithCode||[""]}
              getOptionLabel={(option)=>option?.name}
              renderInput={(params)=><TextField {...params}/>}
              value={addPackage?.country}
              onChange={getAddPackage('country')}
            />
          </div>
          <div className="global-single-input auto-complete" style={{width:"30%"}}>
            <p>Type of ERP</p>
            <Autocomplete
              sx={{width:"100%"}}
              options={ErpTypes||[""]}
              getOptionLabel={(option)=>option?.name}
              renderInput={(params)=><TextField {...params}/>}
              value={addPackage?.typeOfErp}
              onChange={getAddPackage('typeOfErp')}
            />
          </div>
          <div className="global-single-input" style={{width:"30%"}}>

            <p>Distribution Price</p>
            <input type="text"
              value={addPackage?.distributionPrice}
              onChange={getAddPackage('distributionPrice')}
            />
            

          </div>
          <div
            className="global-single-input auto-complete"
            style={{ position: "relative",width:"30%" }}
          >
            <p>Duration</p>
            <div style={{display:"flex"}}>
            <Autocomplete
              sx={{width:"100%"}}
              options={durationType||[""]}
              getOptionLabel={(option)=>option?.name}
              renderInput={(params)=><TextField {...params}/>}
              value={addPackage?.packageDuration}
              onChange={getAddPackage('packageDuration')}
            />
            <input 
              type="text" 
              style={{width:"50%",marginLeft:"4px"}}
              value={addPackage?.durationType}
              onChange={getAddPackage('durationType')}
              placeholder="Duration value"
              />
            </div>
           
            {/* <div className="package-module-add-btn">
              <button onClick={clickPackageDuration}>
                Add Duration
              </button>
            </div> */}
          </div>
          {/* <div
            className="global-single-input auto-complete"
            style={{ position: "relative",width:"30%" }}
          >
            <p>Duration Type</p>
            <Autocomplete
              sx={{width:"100%"}}
              options={[{type:"Year"}]||[""]}
              getOptionLabel={(option)=>option?.type}
              renderInput={(params)=><TextField {...params}/>}
              value={addPackage?.durationType}
              onChange={getAddPackage('durationType')}
            />
           
          </div> */}
          <div className="global-single-input" style={{width:"30%"}}>
            <p>Backup Price</p>
            <input type="text"
              value={addPackage?.backupPrice}
              onChange={getAddPackage('backupPrice')}
             />

          </div>
          {/* Hide the legacy "Types Of Plans" picker for ERP-LEEYET — the
              LEEYET Bundle below acts as the plan and is auto-linked on submit. */}
          {addPackage?.typeOfErp?.name !== "ERP-LEEYET" && (
          <div
            className="global-single-input auto-complete"
            style={{ position: "relative",width:"30%" }}
          >
            <p>Types Of Plans</p>
            <Autocomplete
              sx={{width:"100%"}}
              options={planList||[""]}
              getOptionLabel={(option)=>option?.name}
              renderInput={(params)=><TextField {...params}/>}
               value={addPackage?.planType}
               onChange={getAddPackage('planType')}
            />
            <div className="package-module-add-btn">
              <button onClick={()=>setAddPlan(true)}>
                Add Plan
              </button>
            </div>
          </div>
          )}
          <div
            className="global-single-input auto-complete"
            style={{ position: "relative",width:"30%" }}
          >
            <p>Select Sub Modules</p>
            {/* <Autocomplete
              sx={{width:"100%"}}
              options={[""]}
              getOptionLabel={(option)=>option}
              renderInput={(params)=><TextField {...params}/>}
             
            /> */}
            <input 
            type="text" 
            onClick={()=>setAddSubModule(true)} placeholder="Select module"/>
           
          </div>
          <div
            className="global-single-input auto-complete"
            style={{ position: "relative",width:"30%" }}
          >
            <p>Select Content</p>
              <input 
                type="text"  placeholder="Add Content"
                onClick={()=>setContentPopup(true)}
                />
            {/* <Autocomplete
              sx={{width:"100%"}}
              options={[""]}
              getOptionLabel={(option)=>option}
              renderInput={(params)=><TextField {...params}/>}
            /> */}
            {/* <div className="package-module-add-btn">
              <button>
                Add Content
              </button>
            </div> */}
          </div>
         
         
          <div className="global-single-input" style={{width:"30%"}}>
            <p>Adding Location Price</p>
            <input type="text"
            value={addPackage?.addingLocationPrice}
            onChange={getAddPackage('addingLocationPrice')}
            />
          </div>
          {/* <div className="global-single-input" style={{width:"30%"}}>
            <p>Plan Price</p>
            <input type="text"
               value={addPackage?.planPrice}
               onChange={getAddPackage('planPrice')}
            />
          </div> */}
          <div className="global-single-input" style={{width:"30%"}}>
            <p>Plan Price</p>
            <input type="text"
            value={addPackage?.sellingPrice}
            onChange={getAddPackage('sellingPrice')}
            />
          </div>
          <div className="global-single-input" style={{width:"30%"}}>
            <p>Package Saved %</p>
            <input type="text"
            />
          </div>
       
          <div  style={{width:"30%",display:"flex",justifyContent:"space-between",margin:"1%"}}>
            <div className="global-single-input" style={{width:"48%"}}>
               <p>Mobile Package Price</p>
               <input 
                 type="text"  
                 style={{width:"90%"}}
                 value={addPackage?.mobilepackagePrice}
               onChange={getAddPackage('mobilepackagePrice')}
                 />
            </div>
            <div className="global-single-input" style={{width:"48%"}}>
               <p>Location Price</p>
               <input 
                 type="text" 
                 style={{width:"90%"}}
                 value={addPackage?.mobileLocPrice}
                 onChange={getAddPackage('mobileLocPrice')}
                 />
            </div>
           
          </div>
          <div  style={{width:"30%",display:"flex",justifyContent:"space-between",margin:"1%"}}>
            <div className="global-single-input" style={{width:"58%"}}>
               <p>Upload Image</p>
               <div className="upload-image-input">
                  <input 
                    type="text"  
                     style={{width:"90%"}}
                     value={imageName}
                 />
                 <input type="file" id="card-logo" onChange={getImage}/>
                   <Tooltip title="Upload Image">
                   <label htmlFor="card-logo">
                    Upload&nbsp;&nbsp;&nbsp;<img src={uploadIcon} alt="uploadIcon" />
                   </label> 
                 </Tooltip>
               </div>
             
            </div>
            <div className="global-single-input" style={{width:"38%"}}>
               <p>Add Colour</p>
               <div className="add-color-container">
                    <input 
                      type="text" 
                      value={addPackage?.color} 
                      style={{width:"87%"}}
                      onPaste={handlePaste}
                      onChange={getAddPackage('color')}
                      />
                    <input 
                        type="color" 
                        value={addPackage.color}
                        onChange={getAddPackage('color')}

                 />
               </div>
             
            </div>
          
           
          </div>
          <div className="global-single-input" style={{width:"30%"}}>
               <p>Description</p>
               <textarea 
                  type="text"
                  name="" id="" cols="30" rows="4"
                  value={addPackage?.discription}
                  onChange={getAddPackage('discription')}
                  ></textarea>
            </div>
            <div
            className="global-single-input"
            style={{ position: "relative",width:"15%" }}
          >
            <p>Tax %</p>
            <input 
              type="number" 
              placeholder="e.g., 5, 15, 18"
              value={addPackage?.taxPercentage || ''}
              onChange={(e) => setAddPackage({...addPackage, taxPercentage: e.target.value})}
            />
          </div>
          
          <div
            className="global-single-input"
            style={{ position: "relative",width:"15%" }}
          >
            <p>Tax Type</p>
            <select 
              value={addPackage?.taxType || 'VAT'}
              onChange={(e) => setAddPackage({...addPackage, taxType: e.target.value})}
            >
              <option value="VAT">VAT</option>
              <option value="GST">GST</option>
              <option value="Sales Tax">Sales Tax</option>
              <option value="Service Tax">Service Tax</option>
            </select>
          </div>
        
        

         
        
         
        </div>

        {/* Seat-license configuration (LEEYET bundle + Hospitality license) */}
        {_isLicensed && (
          <div
            style={{
              border: "1px solid #c4b5fd",
              background: "#f5f3ff",
              borderRadius: 12,
              padding: 16,
              marginTop: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
              <h4 style={{ margin: 0, color: "#5b21b6" }}>
                {_isLeeyet ? "LEEYET Bundle Configuration" : "Hospitality Bundle Configuration"}
              </h4>
              <span style={{ fontSize: 12, color: "#6d28d9" }}>
                Picking a preset auto-fills modules, tiers, AI quota and max users. You can still tweak each field afterwards.
              </span>
            </div>

            <div className="add-package-form" style={{ alignItems: "flex-end" }}>
              <div className="global-single-input auto-complete" style={{ width: "30%" }}>
                <p>Bundle</p>
                <Autocomplete
                  sx={{ width: "100%" }}
                  options={_bundleOptions}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) => option?.value === value?.value}
                  renderInput={(params) => <TextField {...params} />}
                  value={addPackage?.leeyetBundle}
                  onChange={(_e, newValue) => {
                    const preset = newValue?.value && _bundlePresets[newValue.value];
                    if (preset) {
                      setAddPackage({
                        ...addPackage,
                        leeyetBundle: newValue,
                        leeyetMaxUsers: preset.maxUsers,
                        leeyetAiMonthlyRequests: preset.aiMonthlyRequests,
                        leeyetAiModelTier: preset.aiModelTier,
                        leeyetModuleCrm: preset.modules.crm,
                        leeyetModuleBooks: preset.modules.books,
                        leeyetModulePeople: preset.modules.people,
                        leeyetModulePayroll: preset.modules.payroll,
                        leeyetModulePublish: preset.modules.publish,
                        leeyetModulePos: preset.modules.pos,
                        leeyetTierCrm: preset.tiers.crm,
                        leeyetTierBooks: preset.tiers.books,
                        leeyetTierPeople: preset.tiers.people,
                        leeyetTierPayroll: preset.tiers.payroll,
                        leeyetTierPublish: preset.tiers.publish,
                        leeyetTierPos: preset.tiers.pos,
                      });
                    } else {
                      setAddPackage({ ...addPackage, leeyetBundle: newValue });
                    }
                  }}
                />
              </div>

              <div className="global-single-input" style={{ width: "20%" }}>
                <p>Max Users (0 = unlimited)</p>
                <input
                  type="number"
                  min={0}
                  value={addPackage?.leeyetMaxUsers ?? 0}
                  onChange={(e) => setAddPackage({ ...addPackage, leeyetMaxUsers: e.target.value })}
                />
              </div>

              <div className="global-single-input" style={{ width: "22%" }}>
                <p>AI Monthly Requests (0 = unlimited)</p>
                <input
                  type="number"
                  min={0}
                  value={addPackage?.leeyetAiMonthlyRequests ?? 0}
                  onChange={(e) => setAddPackage({ ...addPackage, leeyetAiMonthlyRequests: e.target.value })}
                />
              </div>

              <div className="global-single-input" style={{ width: "22%" }}>
                <p>AI Model Tier</p>
                <select
                  value={addPackage?.leeyetAiModelTier || "basic"}
                  onChange={(e) => setAddPackage({ ...addPackage, leeyetAiModelTier: e.target.value })}
                >
                  {LEEYET_AI_TIER_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>

              <div className="global-single-input" style={{ width: "30%" }}>
                <p>License Rate (per extra seat)</p>
                <input
                  type="number"
                  min={0}
                  step="0.01"
                  placeholder="0.00"
                  value={addPackage?.leeyetLicenseRate ?? 0}
                  onChange={(e) => setAddPackage({ ...addPackage, leeyetLicenseRate: e.target.value })}
                />
                <small style={{ color: "#6d28d9", fontSize: 11 }}>
                  Charged per additional seat when admin manually adds licenses for a customer.
                </small>
              </div>
            </div>

            {/* Subscription tiers / Billing cycles repeater */}
            <div style={{ marginTop: 16 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <p style={{ margin: 0, fontWeight: 600, color: "#4c1d95" }}>
                  Subscription Tiers (Billing Cycles)
                </p>
                <button
                  type="button"
                  className="global-button-contained-blue"
                  style={{ padding: "2px 10px", fontSize: 12 }}
                  onClick={() =>
                    setAddPackage({
                      ...addPackage,
                      leeyetBillingCycles: [
                        ...(addPackage?.leeyetBillingCycles || []),
                        { code: "", label: "", durationValue: 1, durationUnit: "Month",
                          price: 0, benefit: "", discountPercent: 0, isDefault: false, isActive: true },
                      ],
                    })
                  }
                >
                  + Add Cycle
                </button>
              </div>
              <small style={{ color: "#6b7280", fontSize: 11, display: "block", marginBottom: 8 }}>
                Define the billing cycles customers can choose at purchase. Pick one as the default.
                Yearly tiers usually show savings vs monthly (set <i>Discount %</i> or <i>Benefit text</i>).
              </small>
              <div style={{ display: "grid", gap: 6 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr 0.7fr 0.9fr 1fr 1.4fr 0.7fr 0.7fr 0.5fr 0.5fr", gap: 6, fontSize: 11, color: "#6b7280", fontWeight: 600 }}>
                  <div>Code</div>
                  <div>Label</div>
                  <div>Qty</div>
                  <div>Unit</div>
                  <div>Price</div>
                  <div>Benefit text</div>
                  <div>Disc %</div>
                  <div>Default</div>
                  <div>Active</div>
                  <div></div>
                </div>
                {(addPackage?.leeyetBillingCycles || []).map((c, idx) => {
                  const updateCycle = (patch) => {
                    const next = [...(addPackage?.leeyetBillingCycles || [])];
                    next[idx] = { ...next[idx], ...patch };
                    if (patch.isDefault) {
                      next.forEach((row, i) => { if (i !== idx) row.isDefault = false; });
                    }
                    setAddPackage({ ...addPackage, leeyetBillingCycles: next });
                  };
                  const removeCycle = () => {
                    const next = (addPackage?.leeyetBillingCycles || []).filter((_, i) => i !== idx);
                    setAddPackage({ ...addPackage, leeyetBillingCycles: next });
                  };
                  return (
                    <div key={idx} style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr 0.7fr 0.9fr 1fr 1.4fr 0.7fr 0.7fr 0.5fr 0.5fr", gap: 6, alignItems: "center" }}>
                      <input type="text" placeholder="monthly" value={c.code}
                        onChange={(e) => updateCycle({ code: e.target.value })} />
                      <input type="text" placeholder="Monthly" value={c.label}
                        onChange={(e) => updateCycle({ label: e.target.value })} />
                      <input type="number" min={1} value={c.durationValue}
                        onChange={(e) => updateCycle({ durationValue: e.target.value })} />
                      <select value={c.durationUnit}
                        onChange={(e) => updateCycle({ durationUnit: e.target.value })}>
                        <option value="Day">Day</option>
                        <option value="Month">Month</option>
                        <option value="Year">Year</option>
                      </select>
                      <input type="number" min={0} step="0.01" value={c.price}
                        onChange={(e) => updateCycle({ price: e.target.value })} />
                      <input type="text" placeholder="Save 20% vs monthly" value={c.benefit}
                        onChange={(e) => updateCycle({ benefit: e.target.value })} />
                      <input type="number" min={0} max={100} step="0.1" value={c.discountPercent}
                        onChange={(e) => updateCycle({ discountPercent: e.target.value })} />
                      <input type="radio" name="leeyetBillingDefault" checked={!!c.isDefault}
                        onChange={() => updateCycle({ isDefault: true })} />
                      <input type="checkbox" checked={c.isActive !== false}
                        onChange={(e) => updateCycle({ isActive: e.target.checked })} />
                      <button type="button" onClick={removeCycle}
                        style={{ background: "transparent", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 16 }}
                        title="Remove cycle">×</button>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <p style={{ marginBottom: 6, fontWeight: 600, color: "#4c1d95" }}>Modules &amp; per-module tiers</p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
                {[
                  { label: "CRM",     enabledKey: "leeyetModuleCrm",     tierKey: "leeyetTierCrm" },
                  { label: "Books",   enabledKey: "leeyetModuleBooks",   tierKey: "leeyetTierBooks" },
                  { label: "People",  enabledKey: "leeyetModulePeople",  tierKey: "leeyetTierPeople" },
                  { label: "Payroll", enabledKey: "leeyetModulePayroll", tierKey: "leeyetTierPayroll" },
                  { label: "Publish", enabledKey: "leeyetModulePublish", tierKey: "leeyetTierPublish" },
                  { label: "POS",     enabledKey: "leeyetModulePos",     tierKey: "leeyetTierPos" },
                ].map((m) => (
                  <div
                    key={m.label}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      background: "#fff",
                      border: "1px solid #ddd6fe",
                      borderRadius: 8,
                      padding: "8px 10px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={!!addPackage?.[m.enabledKey]}
                      onChange={(e) => setAddPackage({ ...addPackage, [m.enabledKey]: e.target.checked })}
                      style={{ width: 16, height: 16, accentColor: "#7c3aed" }}
                    />
                    <span style={{ minWidth: 64, fontWeight: 600 }}>{m.label}</span>
                    <select
                      value={addPackage?.[m.tierKey] || "none"}
                      onChange={(e) => setAddPackage({ ...addPackage, [m.tierKey]: e.target.value })}
                      disabled={!addPackage?.[m.enabledKey]}
                      style={{ marginLeft: "auto", minWidth: 110 }}
                    >
                      {LEEYET_TIER_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                ))}
              </div>
            </div>

            {/* =============================================================
                AI Integration — provider + API key for this bundle.
                'Leeyet AI' uses the platform's built-in key. Selecting
                Gemini/OpenAI/Azure reveals key + model fields. The Test
                button pings the provider end-to-end through the
                @leeyet/ai-gateway library on the backend.
              ============================================================= */}
            <div style={{ marginTop: 18, padding: 12, background: "#fafaff", border: "1px dashed #c4b5fd", borderRadius: 8 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <p style={{ margin: 0, fontWeight: 600, color: "#4c1d95" }}>
                  AI Integration (Gemini / OpenAI / Azure / Leeyet)
                </p>
                <span style={{ fontSize: 12, color: "#6d28d9" }}>
                  Used by CRM, Books, People, Payroll, Publish & POS AI features.
                </span>
              </div>
              <p style={{ margin: "0 0 10px", fontSize: 12, color: "#6b7280" }}>
                The <strong>Default Provider</strong> below is what customers on
                this package get when they pick <em>"Leeyet AI (built-in)"</em>
                in CRM. Any other providers you save here are kept as
                automatic fallbacks &mdash; if the default's key fails (revoked,
                quota exhausted, upstream 5xx), the gateway transparently
                retries with the next saved provider.
              </p>

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
                <div className="global-single-input" style={{ width: "28%" }}>
                  <p>Default Provider</p>
                  <select
                    value={addPackage?.leeyetAiProvider || "leeyet"}
                    onChange={(e) => {
                      const newProv = e.target.value;
                      const oldProv = addPackage?.leeyetAiProvider || "leeyet";
                      // Save current provider's settings into the local map
                      // before switching, so we can restore them later.
                      const pcMap = { ...(addPackage?.leeyetAiProviderConfigs || {}) };
                      if (oldProv && oldProv !== "leeyet") {
                        pcMap[oldProv] = {
                          apiKeyMasked:    addPackage?.leeyetAiApiKeyMasked || "",
                          baseUrl:         addPackage?.leeyetAiBaseUrl      || "",
                          chatModel:       addPackage?.leeyetAiChatModel    || "",
                          embedModel:      addPackage?.leeyetAiEmbedModel   || "",
                          endpoint:        addPackage?.leeyetAiEndpoint     || "",
                          chatDeployment:  addPackage?.leeyetAiChatDeployment || "",
                          embedDeployment: addPackage?.leeyetAiEmbedDeployment || "",
                          apiVersion:      addPackage?.leeyetAiApiVersion   || "",
                        };
                      }
                      // Restore saved config for the new provider (if any).
                      const restored = pcMap[newProv] || {};
                      setAddPackage({
                        ...addPackage,
                        leeyetAiProvider: newProv,
                        leeyetAiProviderConfigs: pcMap,
                        // Restore or blank each field.
                        leeyetAiApiKey:          "",          // never carry raw key
                        leeyetAiApiKeyMasked:    restored.apiKeyMasked    || "",
                        leeyetAiChatModel:       restored.chatModel       || "",
                        leeyetAiEmbedModel:      restored.embedModel      || "",
                        leeyetAiBaseUrl:         restored.baseUrl         || "",
                        leeyetAiEndpoint:        restored.endpoint        || "",
                        leeyetAiChatDeployment:  restored.chatDeployment  || "",
                        leeyetAiEmbedDeployment: restored.embedDeployment || "",
                        leeyetAiApiVersion:      restored.apiVersion      || "",
                        // Clear test status on provider change.
                        leeyetAiLastTestStatus:  "",
                        leeyetAiLastTestError:   "",
                        leeyetAiTestMsg:         "",
                      });
                    }}
                  >
                    {LEEYET_AI_PROVIDER_OPTIONS.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </div>

                {addPackage?.leeyetAiProvider && addPackage.leeyetAiProvider !== "leeyet" ? (
                  <>
                    <div className="global-single-input" style={{ width: "32%" }}>
                      <p>
                        API Key
                        {addPackage?.leeyetAiApiKeyMasked
                          ? <span style={{ fontSize: 11, color: "#6d28d9", marginLeft: 6 }}>
                              (saved: {addPackage.leeyetAiApiKeyMasked} — leave blank to keep)
                            </span>
                          : null}
                      </p>
                      <input
                        type="password"
                        placeholder={addPackage?.leeyetAiApiKeyMasked ? "Paste a new key to replace" : "Paste API key"}
                        value={addPackage?.leeyetAiApiKey || ""}
                        autoComplete="new-password"
                        onChange={(e) => setAddPackage({ ...addPackage, leeyetAiApiKey: e.target.value })}
                      />
                    </div>

                    {/* Chat model / embed model pickers — curated dropdown
                        per provider with a "Custom…" escape hatch for exotic
                        deployments. Selecting "Custom…" reveals a text input
                        next to the dropdown. */}
                    {addPackage.leeyetAiProvider !== "azure" ? (() => {
                      const chatList  = LEEYET_AI_MODEL_CATALOG[addPackage.leeyetAiProvider] || [];
                      const embedList = LEEYET_AI_EMBED_CATALOG[addPackage.leeyetAiProvider] || [];
                      const chatVal   = addPackage?.leeyetAiChatModel  || "";
                      const embedVal  = addPackage?.leeyetAiEmbedModel || "";
                      const chatIsCustom  = !!chatVal  && !chatList.some((o) => o.value === chatVal);
                      const embedIsCustom = !!embedVal && !embedList.some((o) => o.value === embedVal);
                      return (
                        <>
                          <div className="global-single-input" style={{ width: "22%" }}>
                            <p>Chat model</p>
                            <select
                              value={chatIsCustom ? "__custom" : chatVal}
                              onChange={(e) => {
                                const v = e.target.value;
                                if (v === "__custom") {
                                  // Pre-fill the custom input with the default so
                                  // the field isn't empty after switching.
                                  setAddPackage({ ...addPackage, leeyetAiChatModel: chatList[0]?.value || "" });
                                } else if (v === "__default") {
                                  setAddPackage({ ...addPackage, leeyetAiChatModel: "" });
                                } else {
                                  setAddPackage({ ...addPackage, leeyetAiChatModel: v });
                                }
                              }}
                            >
                              <option value="__default">Auto ({chatList[0]?.value || "default"})</option>
                              {chatList.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                              ))}
                              <option value="__custom">Custom…</option>
                            </select>
                            {chatIsCustom ? (
                              <input
                                type="text"
                                placeholder="Type model id"
                                value={chatVal}
                                onChange={(e) => setAddPackage({ ...addPackage, leeyetAiChatModel: e.target.value })}
                                style={{ marginTop: 4 }}
                              />
                            ) : null}
                          </div>
                          <div className="global-single-input" style={{ width: "22%" }}>
                            <p>Embed model</p>
                            <select
                              value={embedIsCustom ? "__custom" : embedVal}
                              onChange={(e) => {
                                const v = e.target.value;
                                if (v === "__custom") {
                                  setAddPackage({ ...addPackage, leeyetAiEmbedModel: embedList[0]?.value || "" });
                                } else if (v === "__default") {
                                  setAddPackage({ ...addPackage, leeyetAiEmbedModel: "" });
                                } else {
                                  setAddPackage({ ...addPackage, leeyetAiEmbedModel: v });
                                }
                              }}
                            >
                              <option value="__default">Auto ({embedList[0]?.value || "default"})</option>
                              {embedList.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                              ))}
                              <option value="__custom">Custom…</option>
                            </select>
                            {embedIsCustom ? (
                              <input
                                type="text"
                                placeholder="Type model id"
                                value={embedVal}
                                onChange={(e) => setAddPackage({ ...addPackage, leeyetAiEmbedModel: e.target.value })}
                                style={{ marginTop: 4 }}
                              />
                            ) : null}
                          </div>
                        </>
                      );
                    })() : null}

                    {addPackage.leeyetAiProvider === "azure" ? (
                      <>
                        <div className="global-single-input" style={{ width: "24%" }}>
                          <p>Endpoint</p>
                          <input
                            type="text"
                            placeholder="https://your-resource.openai.azure.com"
                            value={addPackage?.leeyetAiEndpoint || ""}
                            onChange={(e) => setAddPackage({ ...addPackage, leeyetAiEndpoint: e.target.value })}
                          />
                        </div>
                        <div className="global-single-input" style={{ width: "16%" }}>
                          <p>Chat deployment</p>
                          <input
                            type="text"
                            value={addPackage?.leeyetAiChatDeployment || ""}
                            onChange={(e) => setAddPackage({ ...addPackage, leeyetAiChatDeployment: e.target.value })}
                          />
                        </div>
                        <div className="global-single-input" style={{ width: "16%" }}>
                          <p>Embed deployment</p>
                          <input
                            type="text"
                            value={addPackage?.leeyetAiEmbedDeployment || ""}
                            onChange={(e) => setAddPackage({ ...addPackage, leeyetAiEmbedDeployment: e.target.value })}
                          />
                        </div>
                        <div className="global-single-input" style={{ width: "14%" }}>
                          <p>API version</p>
                          <input
                            type="text"
                            placeholder="2024-02-15-preview"
                            value={addPackage?.leeyetAiApiVersion || ""}
                            onChange={(e) => setAddPackage({ ...addPackage, leeyetAiApiVersion: e.target.value })}
                          />
                        </div>
                      </>
                    ) : null}

                    <div style={{ marginLeft: "auto", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                      <button
                        type="button"
                        className="global-button-contained-blue"
                        disabled={!!addPackage?.leeyetAiTesting || (!addPackage?.leeyetAiApiKey && !addPackage?.leeyetAiApiKeyMasked)}
                        title={!addPackage?.leeyetAiApiKey && !addPackage?.leeyetAiApiKeyMasked
                          ? "Paste an API key first"
                          : "Send a tiny ping prompt to confirm the key works"}
                        onClick={async () => {
                          setAddPackage((p) => ({ ...p, leeyetAiTesting: true, leeyetAiTestMsg: "" }));
                          const out = await testAiKeyAPICall({
                            packageId: singlePackage?._id || undefined,
                            aiConfig: {
                              provider:        addPackage?.leeyetAiProvider,
                              apiKey:          (addPackage?.leeyetAiApiKey || "").trim(),
                              baseUrl:         addPackage?.leeyetAiBaseUrl,
                              chatModel:       addPackage?.leeyetAiChatModel,
                              embedModel:      addPackage?.leeyetAiEmbedModel,
                              endpoint:        addPackage?.leeyetAiEndpoint,
                              chatDeployment:  addPackage?.leeyetAiChatDeployment,
                              embedDeployment: addPackage?.leeyetAiEmbedDeployment,
                              apiVersion:      addPackage?.leeyetAiApiVersion,
                            },
                          });
                          setAddPackage((p) => ({
                            ...p,
                            leeyetAiTesting: false,
                            leeyetAiLastTestStatus: out && out.ok ? "ok" : "fail",
                            leeyetAiLastTestError: (out && out.error) || "",
                            leeyetAiTestMsg: out && out.ok
                              ? `OK · ${out.provider || ""}${out.sample ? ` · "${String(out.sample).slice(0, 40)}"` : ""}`
                              : `Failed: ${out && out.error || "unknown error"}`,
                          }));
                        }}
                      >
                        {addPackage?.leeyetAiTesting ? "Testing…" : "Test"}
                      </button>
                      {addPackage?.leeyetAiTestMsg ? (
                        <span style={{
                          fontSize: 11,
                          color: addPackage?.leeyetAiLastTestStatus === "ok" ? "#047857" : "#b91c1c",
                          maxWidth: 220,
                          textAlign: "right",
                        }}>
                          {addPackage.leeyetAiTestMsg}
                        </span>
                      ) : addPackage?.leeyetAiLastTestStatus ? (
                        <span style={{
                          fontSize: 11,
                          color: addPackage.leeyetAiLastTestStatus === "ok" ? "#047857" : "#b91c1c",
                        }}>
                          Last test: {addPackage.leeyetAiLastTestStatus}
                          {addPackage.leeyetAiLastTestError ? ` — ${addPackage.leeyetAiLastTestError.slice(0, 60)}` : ""}
                        </span>
                      ) : null}
                    </div>
                  </>
                ) : (
                  <div style={{ flex: 1, fontSize: 12, color: "#6d28d9", paddingBottom: 8 }}>
                    Using the platform's built-in Leeyet AI key (no per-bundle key required).
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Turnover-Based Billing Configuration */}
        <TurnoverConfig addPackage={addPackage} setAddPackage={setAddPackage} />


       
        <div className="package-plans-cancel-submit-btn-container">
          <button className="global-button-contained-black-outlined">
            Cancel
          </button>
          <button className="global-button-contained-blue" 
            onClick={singlePackage === undefined ? packageSubmitBtnFn:editSubmitFunction}
          >{singlePackage === undefined ?"Submit":"Update"}</button>
        </div>
      </div>
      <div className="global-container">
          {/* <div className="global-single-input auto-complete" style={{width:"30%"}}>
            <p>Select Country</p>
            <Autocomplete
              sx={{width:"100%"}}
              options={CountryListWithCode||[""]}
              getOptionLabel={(option)=>option?.name}
              renderInput={(params)=><TextField {...params} placeholder="Select Country"/>}
              value={country}
              onChange={(e,newValue)=>setCountry(newValue)}
            />
          </div> */}
        <div className="global-container-table">
          <table>
            <thead>
              <tr>
                <th>Transaction ID</th>
                <th>Country</th>
                <th>Type of ERP</th>
                <th>Plan Type</th>
                <th>Billing Type</th>
                <th>Distribution Price</th>
                <th>Selling Price</th>
                <th>Trial Period(Days)</th>
                <th>Location Price</th>
                <th>Backup Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                // Sort by latest first (reverse order) and paginate
                packageList
                  ?.slice()
                  .reverse()
                  .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                  .map((r,i)=>(
                  <tr key={r?._id}>
                  <td>{r?.packageId}</td>
                  <td>{r?.country}</td>
                  <td>{r?.packageName}</td>
                  <td>{r?.plans?.name}</td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      backgroundColor: r?.billingType === 'turnover' ? '#e3f2fd' : '#f5f5f5',
                      color: r?.billingType === 'turnover' ? '#1976d2' : '#666'
                    }}>
                      {r?.billingType === 'turnover' ? 'Turnover' : 'Fixed'}
                    </span>
                  </td>
                  <td>{r?.distributionPrice}</td>
                  <td>
                    {r?.billingType === 'turnover' && r?.turnoverConfig?.basePrice 
                      ? `${r.turnoverConfig.basePrice} (Base)` 
                      : r?.sellingPrice}
                  </td>
                  <td>{r?.packageDuration}</td>
                  <td>{r?.locationPrice}</td>
                  <td>{r?.backupPrice}</td>
                  <td>
                    {/* <IconButton >
                      <VisibilityOutlined sx={{ color: "#83a62f" }} />
                    </IconButton> */}
                    <IconButton onClick={()=>editPackageFunction(r?._id)}>
                      <EditOutlinedIcon sx={{color:"blue"}} />
                    </IconButton>
                    <IconButton onClick={()=>deletePackageFn(r?._id)}>
                      <DeleteOutlineOutlinedIcon sx={{ color: "#fd0301" }} />
                    </IconButton>
                  </td>
                </tr>
                ))
              }
             
            </tbody>
          </table>
          
          {/* Pagination Controls */}
          {packageList && packageList.length > itemsPerPage && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              padding: '20px',
              borderTop: '1px solid #e0e0e0'
            }}>
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.5 : 1
                }}
              >
                Previous
              </button>
              
              <span style={{ fontSize: '0.9rem', color: '#666' }}>
                Page {currentPage} of {Math.ceil(packageList.length / itemsPerPage)} 
                ({packageList.length} total packages)
              </span>
              
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(packageList.length / itemsPerPage)))}
                disabled={currentPage === Math.ceil(packageList.length / itemsPerPage)}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: currentPage === Math.ceil(packageList.length / itemsPerPage) ? 'not-allowed' : 'pointer',
                  opacity: currentPage === Math.ceil(packageList.length / itemsPerPage) ? 0.5 : 1
                }}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
     
      <PackageDuration   open={openPackage}   onClose={closeConfirmDialog}   packageDuration={packageDurationList} update={updateListner} />
     
    
         {/* add plan */}
        <Dialog maxWidth="lg"  open={addPlan}>
            <div className="package-parent">
               <div className="package-head-container">
                  <h2>Select Plan</h2>
               </div>
               <div className="package-body-container">
               <div className="package-body-container-left" >
                  <div className="global-single-input auto-complete" style={{width:'100%'}}>
                    <p>Plans</p>
                    {/* <Autocomplete
                       sx={{width:"100%"}}
                       options={[""]}
                       getOptionLabel={(option)=>option}
                       renderInput={(params)=><TextField {...params}/>}
             
                      /> */}
  
                      <input type="text" value={planType} onChange={(e)=>setplanType(e.target.value)}  />
                   </div>
             
              </div>
            <div className="package-body-container-right">
                    <button onClick={addNewPlan}>Add</button>
            </div>
               </div>
               <div className="package-container-table">
           <table>
                  <thead>
                      <tr>
                          <th>plan</th>
                          <th>Action</th>
                          </tr>
                  </thead>
                  <tbody>
                      {
                        planList?.map((r)=>(
                          <tr>
                          <td>{r?.name}</td>
                          <td>
                            <IconButton 
                         
                       
                            >
                               <DeleteOutlineOutlinedIcon sx={{ color: "#fd0301" }}/>
                            </IconButton></td>
                         </tr>
                        ))
                      }
                      
                    
                    
                     
                  </tbody>
              </table>
           </div>
           <div className="package-container-button">
                    <div className="package-container-button-ctn">
                        <button onClick={()=>setAddPlan(false)} className="cancel-btn">Cancel</button>
                    </div>
                    <div className="package-container-button-ctn">
                    <button className="submit-btn">Submit</button>
                    </div>
           </div>
            </div>
        </Dialog>

     
        <AddSubModule open={addSubModule} onClose={()=>setAddSubModule(false)} onDataUpdate={handleSubModuleDataUpdate} dataArray={subModuleArray}/>
        <ContentPopup  open={contentPopup}  onClose={()=>setContentPopup(false)} onDataUpdate={handleContentUpdate} data={contentToBackend}/>
        <SuccessSnackbar
            open={snackBarStates.success}
            handleClose={handleCloseSuccess()}
            message={snackBarStates.snackMsg}
         />
        <ErrorSnackbar
         open={snackBarStates.error}
          handleClose={handleCloseSuccess()}
         message={snackBarStates.snackMsg}
        />
     </>
  );
};

export default PackageAndPlans;
